import SectionHeading from "@/components/feature/SectionHeading";
import { brand } from "@/mocks/site";

export default function TestimonialSection() {
  return (
    <section className="bg-secondary-50">
      <div className="mx-auto w-full max-w-content px-4 py-16 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="读者反馈"
          title="有人因为提前看到，躲过了一次损失"
          description="这些留言来自不同城市的普通读者。我们把这些故事放在这里，是想说明一件事：提前知道，真的有用。"
        />
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {brand.testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-secondary-200 bg-background-50 p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500" aria-hidden="true" />
              <blockquote className="mt-4 flex-1 text-sm leading-7 text-foreground-700">
                {item.quote}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 font-heading text-base font-bold text-secondary-900">
                  {item.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-950">
                    {item.name}
                  </span>
                  <span className="block text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}